<script setup>
  import {
    ref,
    reactive,
    toRefs,
    onMounted,
    onUnmounted,
    computed,
    nextTick,
  } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import dayjs from 'dayjs'
  import {
    getDocMtTaskList,
    deleteTask,
    getTranslateUrl,
    retryDocMtPreprocess,
    refundDocTask,
    refreshDocTwinslatorMtStatus,
  } from '../../../http/api'
  import { DelModal, LoadingModal } from './modal/index'
  import { message } from 'ant-design-vue'

  const route = useRoute()
  const router = useRouter()
  const state = reactive({
    pageNum: 1,
    pageSize: 10,
    total: 0,
    dataSource: [],
    columns: [
      {
        title: '文件名称',
        dataIndex: 'docName',
        slots: { customRender: 'docName' },
        key: 'docName',
      },
      {
        title: '日期',
        dataIndex: 'createTime',
        key: 'createTime',
        slots: { customRender: 'createTime' },
        width: 100,
      },
      {
        title: '语种方向',
        dataIndex: 'language',
        key: 'language',
        slots: { customRender: 'language' },
        width: 100,
      },
      {
        title: '使用引擎',
        dataIndex: 'twinslatorName',
        key: 'twinslatorName',
        width: 100,
      },
      {
        title: '字数',
        dataIndex: 'wordCount',
        key: 'wordCount',
        width: 80,
      },
      {
        title: '文件状态',
        dataIndex: 'docParseStatus',
        key: 'docParseStatus',
        slots: { customRender: 'docParseStatus' },
        width: 160,
      },
      {
        title: '翻译进度',
        dataIndex: 'preStatus',
        key: 'preStatus',
        slots: { customRender: 'preStatus' },
        width: 160,
      },
      {
        title: '操作',
        dataIndex: 'operation',
        key: 'operation',
        slots: { customRender: 'operation' },
        width: 230,
      },
    ],
    loading: false,
    delVisible: false,
    columnDetail: {},
    loadingVisible: false,
    fileType: 1,
    keyword: '',
    preStatus: undefined,
  })

  const listTimer = ref(null)
  const getList = (isLoading = true) => {
    clearTimeout(listTimer.value)
    state.loading = isLoading
    getDocMtTaskList({
      pageNum: state.pageNum,
      pageSize: state.pageSize,
      taskClassify: 10,
      keyword: state.keyword,
      preStatus: state.preStatus,
    })
      .then((res) => {
        const data = res.data.data
        state.dataSource = data.list || []
        state.total = data.total

        let newArr = []
        // docParseStatus 解析状态:  0-待处理 1-处理中 2-处理完成 3-处理失败
        // preStatus 翻译状态: INIT 初始化 ，IN_QUEUE 排队中 ， PROCESSING 进行中 ， SUCCESS 操作成功 ,FAIL 操作失败
        state.dataSource.forEach((item) => {
          if (
            item.docParseStatus == 0 ||
            item.docParseStatus == 1 ||
            (item.docParseStatus == 2 &&
              (item.preStatus == 'INIT' ||
                item.preStatus == 'IN_QUEUE' ||
                item.preStatus == 'PROCESSING'))
          ) {
            newArr.push(item.docId)
          }
        })
        clearTimeout(listTimer.value)
        if (newArr.length > 0) {
          listTimer.value = setTimeout(() => {
            getList(false)
          }, 3000)
        }
      })
      .finally(() => {
        state.loading = false
      })
  }

  const setListStatus = (item) => {
    const newArr = state.dataSource
    newArr.forEach((r) => {
      if (r.docId === item.docId) {
        r.progressStatus = item.progressStatus
        r.progress = item.progress
      }
    })
    nextTick(() => {
      state.dataSource = newArr
    })
  }

  // 分页，页码
  const pageChange = (pageNum) => {
    document.body.scrollTop = document.documentElement.scrollTop = 0
    state.pageNum = pageNum
    getList()
  }

  // 分页，每页条数
  const showSizeChange = (pageNum, pageSize) => {
    document.body.scrollTop = document.documentElement.scrollTop = 0
    state.pageNum = pageNum
    state.pageSize = pageSize
    getList()
  }

  // 显示二次确认删除弹窗
  const showDelModal = (record) => {
    state.delVisible = true
    state.columnDetail = record
  }

  // 删除
  const delFunc = () => {
    deleteTask({ taskIds: state.columnDetail.taskId }).then(() => {
      state.pageNum = 1
      getList()
    })
  }

  //是否不支持导出段段对照
  const isSupportExport = (record) => {
    //是否不支持导出段段对照
    let arrs = [
      'xml',
      'dxf',
      'dwg',
      'json',
      'properties',
      'yaml',
      'yml',
      'xml',
      'xliff',
      'sdlxliff',
      'mqxliff',
      'dita',
    ]
    let fileName = record.docName.split('.').pop().toLowerCase()
    return arrs.includes(fileName)
  }

  //是否不支持导出原文
  const isSupportExportSource = (record) => {
    //是否不支持导出纯原文
    let arrs = ['pdf']
    let fileName = record.docName.split('.').pop().toLowerCase()
    if (arrs.includes(fileName) && record.parseMode == 2) {
      return true
    } else {
      return false
    }
  }
  // 显示loading弹窗
  const showLoadingModel = (record, fileType, isExport) => {
    // 获取文件后缀名
    if (isExport) {
      message.warning('当前稿件格式暂不支持导出该类型')
      return
    }

    state.fileType = fileType
    state.columnDetail = record
    state.loadingVisible = true
  }

  // 深度编辑，前往webcat
  const toWebcat = (record) => {
    if (!record.canWebcatEdit) {
      message.warning('当前稿件格式暂不支持深度编辑')
      return
    }
    const { targetLanguageId, sourceLanguageId, taskId } = record
    getTranslateUrl({
      taskId,
      targetLanguageId,
      sourceLanguageId,
    }).then((res) => {
      const data = res.data
      if (data.result == '1') {
        const url = data.data.url
        window.open(url, '_blank')
      }
    })
  }

  const isNoSupportPreview = (docType) => {
    const fileType = docType.toLowerCase()
    return [
      'html',
      'htm',
      'json',
      'properties',
      'yaml',
      'yml',
      'xml',
      'xliff',
      'sdlxliff',
      'mqxliff',
      'srt',
      'docm',
      'dxf',
      'dwg',
      'dita',
    ].includes(fileType)
  }
  // 前往预览
  const roPreview = (record) => {
    // if(window.__POWERED_BY_QIANKUN__) {
    //   const url = window.config.host+ '/experiencePreview?isTag=open&taskId=' + taskId
    //   window.open(url,'_blank')
    //   return
    // }

    if (isNoSupportPreview(record.docType)) {
      message.warning('当前稿件格式暂不支持查看')
      return
    }
    let activeKey = route.query.activeKey || ''
    const url =
      window.config.toTwinsHome +
      'experiencePreview?taskId=' +
      record.taskId +
      '&activeKey=' +
      activeKey +
      '&enterpriseId=' +
      route.query.enterpriseId
    window.open(url, '_blank')
    return
    router.push({
      path: '/experiencePreview',
      query: {
        taskId: record.taskId,
      },
    })
  }

  // 退款
  const refundFunc = (record) => {
    refundDocTask({
      docId: record.docId,
      taskId: record.taskId,
    }).then((res) => {
      const data = res.data
      if (data.result == 1) {
        message.success('退款成功')
        getList()
      }
    })
  }

  const search = () => {
    state.pageNum = 1
    state.pageSize = 10
    getList()
  }
  const reset = () => {
    state.pageNum = 1
    state.pageSize = 10
    state.keyword = ''
    state.preStatus = undefined
    getList()
  }

  onMounted(() => {
    getList()
  })

  onUnmounted(() => {
    clearTimeout(listTimer.value)
  })

  const {
    dataSource,
    columns,
    pageNum,
    pageSize,
    total,
    loading,
    delVisible,
    loadingVisible,
    fileType,
    columnDetail,
    keyword,
    preStatus,
  } = toRefs(state)

  defineExpose({
    getList,
  })
</script>

<template>
  <div class="doc-translation-list width-1200">
    <div class="flex-align-center margin-tb-16 padding-l-16">
      <svg aria-hidden="true" class="icon">
        <use xlink:href="#icon-lishi-em"></use>
      </svg>
      <span class="font-size-15 color-333 font-weight-600 margin-l-8">
        翻译记录
      </span>
    </div>
    <div class="list-cotent">
      <div class="margin-b-20">
        <a-space :span="10">
          <a-input
            v-model:value="keyword"
            placeholder="文件名称"
            style="width: 200px"
          />
          <a-select
            v-model:value="preStatus"
            style="width: 120px"
            placeholder="翻译进度"
          >
            <a-select-option value="INIT">待翻译</a-select-option>
            <a-select-option value="PROCESSING">翻译中</a-select-option>
            <a-select-option value="SUCCESS">翻译完成</a-select-option>
            <a-select-option value="FAIL">翻译失败</a-select-option>
          </a-select>
          <a-button type="primary" @click="search">查询</a-button>
          <a-button @click="reset">重置</a-button>
        </a-space>
      </div>
      <a-table
        :dataSource="dataSource"
        :columns="columns"
        :pagination="false"
        :loading="loading"
        :row-key="(record) => record.taskId"
      >
        <template #docName="{ text }">
          <a-tooltip class="text-ellipsis-2">
            <template #title>{{ text }}</template>
            {{ text }}
          </a-tooltip>
        </template>
        <template #createTime="{ text }">
          <span>{{ dayjs(+text).format('YYYY.MM.DD') }}</span>
        </template>
        <template #language="{ record, text }">
          <span>{{ record.sourceLangName }} - {{ record.targetLangName }}</span>
        </template>
        <template #wordCount="{ record, text }">
          <span>{{ text > 0 ? text : '-' }}</span>
        </template>
        <template #docParseStatus="{ record, text }">
          <span v-if="text == 0">待解析</span>
          <span v-else-if="text == 1">
            解析中
            <a-progress
              :percent="record.docParseProgress"
              strokeColor="var(--primary-color)"
              class="width-80 margin-l-10"
            />
          </span>
          <span v-else-if="text == 2">解析完成</span>
          <span v-else-if="text == 3" class="color-f55c3f">解析失败</span>
        </template>
        <template #preStatus="{ record, text }">
          <span v-if="text == 'INIT'">待翻译</span>
          <span v-else-if="text == 'PROCESSING'">
            翻译中
            <a-progress
              :percent="record.preProgress"
              strokeColor="var(--primary-color)"
              class="width-80 margin-l-10"
            />
          </span>
          <span v-else-if="text == 'SUCCESS'">翻译完成</span>
          <span v-else-if="text == 'FAIL'" class="color-f55c3f">翻译失败</span>
        </template>
        <template #operation="{ record }">
          <div class="flex-align-center">
            <div
              class="operation-btn"
              :class="{ disabled: isNoSupportPreview(record.docType) }"
              @click="roPreview(record)"
              v-if="record.preStatus == 'SUCCESS'"
            >
              查看
            </div>
            <a-dropdown
              :trigger="['click']"
              placement="bottomCenter"
              v-if="record.preStatus == 'SUCCESS'"
            >
              <a class="operation-btn" @click.prevent>导出</a>
              <template #overlay>
                <a-menu
                  v-if="
                    record.docType == 'jpg' ||
                    record.docType == 'png' ||
                    record.docType == 'jpeg'
                  "
                  class="padding-10"
                >
                  <a-menu-item key="3" @click="showLoadingModel(record, 6)">
                    原图
                  </a-menu-item>
                  <a-menu-item key="1" @click="showLoadingModel(record, 1)">
                    译图
                  </a-menu-item>
                  <a-menu-item key="1" @click="showLoadingModel(record, 99)">
                    可编辑译图docx
                  </a-menu-item>
                </a-menu>
                <a-menu v-else class="padding-10">
                  <a-menu-item key="1" @click="showLoadingModel(record, 1)">
                    纯译文
                  </a-menu-item>
                  <a-menu-item key="2" @click="showLoadingModel(record, 3)">
                    <span>并列对照</span>
                  </a-menu-item>
                  <a-menu-item
                    key="3"
                    @click="
                      showLoadingModel(record, 2, isSupportExport(record))
                    "
                    v-if="record.parseMode == 1"
                  >
                    <span :class="{ 'color-999': isSupportExport(record) }">
                      段段对照（原文在上，译文在下）
                    </span>
                  </a-menu-item>
                  <a-menu-item
                    key="4"
                    @click="
                      showLoadingModel(record, 5, isSupportExport(record))
                    "
                    v-if="record.parseMode == 1"
                  >
                    <span :class="{ 'color-999': isSupportExport(record) }">
                      段段对照（译文在上，原文在下）
                    </span>
                  </a-menu-item>
                  <a-menu-item
                    key="6"
                    @click="
                      showLoadingModel(record, 7, isSupportExport(record))
                    "
                    v-if="
                      record.docType.includes('pdf') ||
                      record.docType.includes('ppt') ||
                      record.docType.includes('doc')
                    "
                  >
                    <span :class="{ 'color-999': isSupportExport(record) }">
                      页页对照（原文在上，译文在下）
                    </span>
                  </a-menu-item>
                  <a-menu-item
                    key="7"
                    @click="
                      showLoadingModel(record, 8, isSupportExport(record))
                    "
                    v-if="
                      record.docType.includes('pdf') ||
                      record.docType.includes('ppt') ||
                      record.docType.includes('doc')
                    "
                  >
                    <span :class="{ 'color-999': isSupportExport(record) }">
                      页页对照（译文在上，原文在下）
                    </span>
                  </a-menu-item>
                  <a-menu-item
                    key="5"
                    @click="
                      showLoadingModel(record, 6, isSupportExportSource(record))
                    "
                  >
                    <span
                      :class="{ 'color-999': isSupportExportSource(record) }"
                    >
                      纯原文
                    </span>
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>

            <div
              class="operation-btn"
              @click="toWebcat(record)"
              :class="{ disabled: !record.canWebcatEdit }"
              v-if="record.preStatus == 'SUCCESS'"
            >
              深度编辑
            </div>
            <!--解析失败展示删除按钮-->
            <div class="operation-btn" @click="showDelModal(record)">删除</div>
            <div
              class="operation-btn"
              v-if="record.refundStatus === 0"
              @click="refundFunc(record)"
            >
              申请退款
            </div>
          </div>
        </template>
      </a-table>
      <div class="pagination-box" v-if="dataSource.length > 0">
        <a-pagination
          show-size-changer
          show-quick-jumper
          :current="pageNum"
          :page-size="pageSize"
          :total="total"
          show-less-items
          @change="pageChange"
          @showSizeChange="showSizeChange"
        />
      </div>
    </div>
    <!-- 二次确认弹窗 -->
    <DelModal v-model:delVisible="delVisible" @on-del="delFunc" />
    <!-- 导出加载弹窗 -->
    <LoadingModal
      v-model:loadingVisible="loadingVisible"
      :fileType="fileType"
      :columnDetail="columnDetail"
    />
  </div>
</template>

<style lang="scss" scoped>
  .doc-translation-list {
    padding-bottom: 30px;
    .list-title {
      display: flex;
      align-items: center;
      height: 60px;
    }
    .list-cotent {
      padding: 20px 20px 0;
      background-color: #fff;
      box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.04);
      border-radius: 8px;
      border: 1px solid #f2f3f5;
      :deep(.ant-table-thead > tr > th) {
        padding: 9px;
        color: #999;
        background: #f6f6f6;
        font-size: 14px;
      }
      :deep(.ant-table-tbody > tr > td) {
        padding: 12px 9px;
      }
    }
    .pagination-box {
      display: flex;
      justify-content: flex-end;
      padding: 20px;
    }
    .operation-btn {
      padding: 5px;
      margin-right: 7px;
      color: var(--primary-color);
      cursor: pointer;
      &.disabled {
        color: #999;
      }
    }
  }
  .width-80 {
    width: 80px;
  }
  .word-break-all {
    word-break: break-all;
  }
  .icon {
    width: 16px;
    height: 16px;
  }
</style>
